export default {
    PLANS: '/plans',
    CSVCALLINGRATES: 'csv-calling-rates',
    CSVNUMBERBLOCKRATES: 'csv-number-block-rates',
};
